/* eslint-disable no-shadow */
import { bindServices } from '@/services/api';
import _ from 'lodash';
import { generateReportToken, updateFavorite } from './service';

const api = bindServices('adminReports');

const meta = {
  page: 1,
  limit: 5,
  count: 0,
  totalPages: 0,
};

const config = {
  groups: {
    action: 'fetchReports',
    select: 'id,title,description,reportGroupId',
    searchSelect: ['title', 'description', 'reportGroup/name'],
    expand: {
      reportGroup: { select: 'id,name' },
    },
  },
  favorites: {
    action: 'fetchFavorites',
    select: 'id,reportId',
    searchSelect: ['report/title', 'report/description'],
    filter: "report/type eq Automy.Core.Enums.ReportType'Administration'",
    expand: {
      report: {
        select: 'id,title,description,reportGroupId',
      },
    },
  },
};

const initialState = {
  list: [],
  currentReport: null,
  currentGroup: null,
  newReport: false,
  newGroup: false,
  pagination: meta,
  reportToken: null,
  activeTab: 'groups',
  searchCriteria: null,
  favorites: [],
  config,
};

const Model = {
  namespace: 'adminReports',
  state: initialState,

  effects: {
    *fetchReports({ payload }, { call, put }) {
      try {
        const response = yield call(api.getAll, {
          route: 'report/adminReports',
          params: payload,
        });
        yield put({ type: 'queryReports', payload: response });
      } catch (e) {
        /*  */
      }
    },

    *fetchFavorites({ payload }, { call, put }) {
      try {
        const response = yield call(api.getAll, {
          route: 'userFavoriteReport',
          params: payload,
        });
        yield put({ type: 'queryFavorites', payload: response });
      } catch (e) {
        /*  */
      }
    },

    *fetchById({ payload }, { put }) {
      yield put({ type: 'queryGoupById', payload });
    },

    *fetchReportById({ payload }, { call, put }) {
      try {
        const item = yield call(api.getById, {
          route: 'report',
          id: payload,
          params: {
            select: `
        id,
        title,
        reportGroupId,
        powerBIReportId,
        powerBIDefaultReportSection,
        powerBIDatasetId,
        isMultipage,
        isReportDataFilterByUserEnabled,
        reportDataFilterUserTableName,
        reportDataFilterUserFieldName,
        reportDataFilterUserFieldNameInternal,
        isReportDataFilterByPositionEnabled,
        reportDataFilterPositionTableName,
        reportDataFilterPositionFieldName,
        reportDataFilterPositionFieldNameInternal,
        isReportDataFilterByUserCompanyEnabled,
        reportDataFilterUserCompanyTableName,
        reportDataFilterUserCompanyFieldName,
        reportDataFilterUserCompanyFieldNameInternal,
        isReportDataFilterByUserEnvironmentEnabled,
        reportDataFilterUserEnvironmentTableName,
        reportDataFilterUserEnvironmentFieldName,
        reportDataFilterUserEnvironmentFieldNameInternal`,
          },
        });
        yield put({ type: 'queryReportById', payload: item });
      } catch (e) {
        /*  */
      }
    },

    *powerBIEmbed({ payload }, { call, put }) {
      try {
        const token = yield call(generateReportToken, payload);
        yield put({ type: 'powerBIEmbed', payload: token });
      } catch (e) {
        /*  */
      }
    },

    *setFavorite({ payload }, { call, put, select }) {
      try {
        yield put({
          type: 'global/setApiRemoteKey',
          payload: { source: payload.id, loading: true },
        });
        yield call(updateFavorite, payload);
        yield put({
          type: 'global/setApiRemoteKey',
          payload: { source: payload.id, loading: false },
        });

        const { config, activeTab: tab } = yield select((st) =>
          _.pick(st.adminReports, ['activeTab', 'config']),
        );

        const type = tab === 'groups' ? 'fetchReports' : 'fetchFavorites';
        yield put({ type, payload: { ...config[tab] } });
        yield put({ type: 'fetchById', payload });
      } catch (e) {
        if (e.message) {
          yield put({
            type: 'global/setApiRemoteKey',
            payload: { source: payload, loading: false },
          });
        }
      }
    },

    *setActiveTab({ payload }, { put }) {
      yield put({ type: 'updateTab', payload });
    },

    *addNewReport({ payload }, { put }) {
      yield put({ type: 'newReport', payload });
    },

    *addNewGroup({ payload }, { put }) {
      yield put({ type: 'newGroup', payload });
    },

    *search({ payload }, { put }) {
      yield put({ type: 'querySearch', payload });
    },

    *cleanReportData(o, { put }) {
      yield put({ type: 'cleanupReportData' });
    },

    *resetState(o, { put }) {
      yield put({ type: 'reset' });
    },
  },
  reducers: {
    queryReports(state, { payload }) {
      const list = _.chain(payload)
        .map('reportGroup')
        .uniqBy('id')
        .map((e) => {
          const reports = _.filter(payload, { reportGroupId: e.id });
          return {
            ...e,
            reports,
            reportsCount: reports.length,
          };
        })
        .value();
      return { ...state, list };
    },

    queryFavorites(state, { payload }) {
      return {
        ...state,
        favorites: _.map(payload, (o) => {
          const { id, report } = o;
          return { favId: id, ...report };
        }),
      };
    },

    queryGoupById(state, { payload }) {
      const currentGroup = _.find(state.list, { id: payload });
      return { ...state, currentGroup };
    },

    queryReportById(state, { payload }) {
      return {
        ...state,
        currentReport: payload,
      };
    },

    powerBIEmbed(state, { payload }) {
      return { ...state, reportToken: payload };
    },

    queryManagement(state, { payload }) {
      return {
        ...state,
        newGroup: false,
        newReport: false,
        response: payload,
      };
    },

    queryGroups(state, { payload }) {
      return {
        ...state,
        list: payload.data,
        currentItem: payload.item,
      };
    },

    addNewReport(state, { payload }) {
      return {
        ...state,
        newGroup: false,
        newReport: payload,
      };
    },

    addNewGroup(state, { payload }) {
      return {
        ...state,
        newReport: false,
        newGroup: payload,
      };
    },

    updateTab(state, { payload }) {
      return {
        ...state,
        activeTab: payload,
      };
    },

    querySearch(state, { payload }) {
      return {
        ...state,
        searchCriteria: payload,
      };
    },

    cleanupReportData(state) {
      return {
        ...state,
        reportToken: null,
        currentReport: null,
      };
    },

    cleanUp(state) {
      return {
        ...state,
        newGroup: false,
        newReport: false,
        currentGroup: null,
        currentReport: null,
        reportToken: null,
      };
    },

    reset() {
      return initialState;
    },
  },
};

export default Model;
